import { OfflineBanner } from '@/components/pwa/OfflineBanner';
import { Onboarding } from '@/components/pwa/Onboarding';
import { PrivacyBanner } from '@/components/pwa/PrivacyBanner';
import { UpdatePrompt } from '@/components/pwa/UpdatePrompt';
import { matchEditor } from '@/lib/nav';
import { EditorRoute } from '@/routes/EditorRoute';
import { GenerateRoute } from '@/routes/GenerateRoute';
import { LandingRoute } from '@/routes/LandingRoute';
import { LibraryRoute } from '@/routes/LibraryRoute';
import { SampleRoute } from '@/routes/SampleRoute';
import { useEffect, useState } from 'react';

export function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  let route: React.ReactElement;
  if (path === '/sample') route = <SampleRoute />;
  else if (path === '/generate') route = <GenerateRoute />;
  else if (path === '/library') route = <LibraryRoute />;
  else {
    const editorId = matchEditor(path);
    if (editorId) route = <EditorRoute ficheId={editorId} />;
    else route = <LandingRoute />;
  }

  return (
    <>
      <OfflineBanner />
      {route}
      <PrivacyBanner />
      <UpdatePrompt />
      <Onboarding />
    </>
  );
}
